import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentLanguage,
  createTranslator,
  selectSupportedLanguages,
  selectI18nLoading,
} from "../store/selectors/i18nSelectors";
import { changeLanguageThunk } from "../store/thunks/i18nThunks";

/**
 * Custom hook for i18n functionality using Redux
 */
export const useI18n = () => {
  const dispatch = useDispatch();
  const language = useSelector(selectCurrentLanguage);
  const t = useSelector(createTranslator);
  const languages = useSelector(selectSupportedLanguages);
  const isLoading = useSelector(selectI18nLoading);

  // Change language function
  const changeLanguage = useCallback(
    (newLang) => {
      dispatch(changeLanguageThunk(newLang));
    },
    [dispatch]
  );

  return {
    t, // Translation function
    language, // Current language code
    languages, // List of supported languages
    changeLanguage, // Function to change language
    isLoading, // Loading state
  };
};
